/**
 * ImageLoading.js
 */

import $ from 'jquery';
import Utilities from './Utilities';
require('imagesloaded');
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';

class ImageLoading {

    constructor() {

		var loadedImageCount, imageCount;

        // Background Image with class of .bg-thumb
		$('.bg-thumb').imagesLoaded( { background: true } )
			.progress( this.onProgress2 );

        // Images from an image tag.
		$('.loading').imagesLoaded()
			.progress( this.onProgress );

    }

	// triggered after each item is loaded
	onProgress(imgLoad, image) {
		$(image.img).removeClass('loading');
	}

	onProgress2(imgLoad, image) {
		$(image.element).removeClass('loading');
	}

}
new ImageLoading();